import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManageSopComponent } from './managesop/manageSop.component';
import { SopComponent } from './sop/sop.component';

import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageSOPManagementModule} from 'ph-bhp-feature-packages/ph-bhp-feature-package-sopmanagement/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';

// common libraries


@NgModule({
  declarations: [
    ManageSopComponent,
    SopComponent
  ],
  imports: [
    CommonModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageSOPManagementModule,
    PhBhpUiModule
  ]
})
export class SopModule { }
